import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventService } from 'src/app/services/event.service';
import { FvrZeropaySupportPopupService } from '../zeropay-support/fvr-zeropay-support-popup.service';

@Component({
  selector: 'app-for-partners',
  templateUrl: './for-partners.component.html',
  styleUrls: ['./for-partners.component.scss']
})
export class ForPartnersComponent implements OnInit, OnDestroy {
  constructor(
    private supportService: FvrZeropaySupportPopupService,
    private eventService: EventService
  ) {}

  public scrollTo(elementId: string): void {
    (document.querySelector(`#${elementId}`) as Element).scrollIntoView({ behavior: "smooth" });
  }

  ngOnInit(): void {
    // this.eventService.howItWorksHide();
    this.eventService.mobileDisplayLogoToolbar.next(true);

  }

  ngOnDestroy(): void {
    this.eventService.howItWorksShow();
  }

  contact() {
    this.supportService.showContactDialog();
  }
}
